module.exports = __webpack_public_path__ + "static/media/chats.d3537895.svg";